import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import API from '../utils/api';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const num = (v) => { const n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? null : n; };

const CATEGORIA_ICONS = {
  'Contenedores y desechables': '📦',
  'Polvos': '🧪',
  'Frutos secos y otros': '🌰',
  'Lácteos y derivados': '🥛',
  'Panadería y repostería': '🍞',
  'Galletas y otros': '🍪',
  'Aseo y limpieza': '🧹',
  'Apliques y papelería': '📎',
};

function Pill({ activo, onClick, children }) {
  return (
    <button onClick={onClick} style={{
      padding: '6px 14px', borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700,
      border: `2px solid ${activo ? '#1a1a2e' : '#E5E7EB'}`,
      background: activo ? '#1a1a2e' : 'white', color: activo ? 'white' : '#374151',
    }}>{children}</button>
  );
}

// ─────────────────────────────────────────
// Tarjeta de ítem
// ─────────────────────────────────────────
function TarjetaItem({ item, valor, onChange, bloqueado }) {
  const [abierto, setAbierto] = useState(false);
  const v = valor || {};
  const tieneCantidad = v.cantidad_actual !== undefined && v.cantidad_actual !== '' && v.cantidad_actual !== null;
  const tieneDetalle = v.ingreso_fecha || v.ingreso_cantidad || v.salida_fecha || v.salida_cantidad || v.observacion;
  const enAlterna = v.unidad_registrada && v.unidad_registrada === item.unidad_alt;

  return (
    <div style={{ background: tieneCantidad ? '#F0FDF4' : 'white', border: '1px solid', borderColor: tieneCantidad ? '#BBF7D0' : '#F3F4F6', borderRadius: 12, padding: '12px 14px', marginBottom: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: 13, color: '#111827' }}>{item.nombre}</div>
          <div style={{ fontSize: 11, color: '#9CA3AF' }}>
            {item.codigo} ·{' '}
            {item.unidad_alt ? (
              <select value={v.unidad_registrada || item.unidad} disabled={bloqueado}
                onChange={e => onChange('unidad_registrada', e.target.value)}
                style={{ border: 'none', background: 'none', fontSize: 11, color: enAlterna ? '#B45309' : '#9CA3AF', fontWeight: enAlterna ? 700 : 400, padding: 0 }}>
                <option value={item.unidad}>{item.unidad}</option>
                <option value={item.unidad_alt}>{item.unidad_alt}</option>
              </select>
            ) : item.unidad}
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <input type="number" step="0.01" value={v.cantidad_actual ?? ''} disabled={bloqueado}
            onChange={e => onChange('cantidad_actual', e.target.value)}
            placeholder="0"
            style={{ width: 84, padding: '9px 8px', border: '2px solid #BFDBFE', borderRadius: 8, fontSize: 15, outline: 'none', textAlign: 'right', background: bloqueado ? '#F9FAFB' : 'white', fontWeight: 700 }} />
          {enAlterna && v.cantidad_actual && item.factor_alt > 0 && (
            <div style={{ fontSize: 10, color: '#0369A1', marginTop: 2 }}>
              = {(num(v.cantidad_actual) / item.factor_alt).toFixed(3)} {item.unidad}
            </div>
          )}
        </div>
      </div>

      <button onClick={() => setAbierto(a => !a)} style={{ marginTop: 8, background: 'none', border: 'none', color: tieneDetalle ? '#4338CA' : '#9CA3AF', fontSize: 11, fontWeight: 700, cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
        {abierto ? '▲' : '▼'} {tieneDetalle ? '✓ Ingreso/Salida/Nota' : 'Ingreso / Salida / Nota (opcional)'}
      </button>

      {abierto && (
        <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid #F3F4F6', display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <div>
              <div style={{ fontSize: 10, fontWeight: 700, color: '#6B7280', marginBottom: 3 }}>Fecha ingreso</div>
              <input type="date" value={v.ingreso_fecha || ''} disabled={bloqueado} onChange={e => onChange('ingreso_fecha', e.target.value)}
                style={{ width: '100%', padding: '7px 8px', border: '1px solid #E5E7EB', borderRadius: 6, fontSize: 12, outline: 'none', boxSizing: 'border-box', background: bloqueado ? '#F9FAFB' : 'white' }} />
            </div>
            <div>
              <div style={{ fontSize: 10, fontWeight: 700, color: '#6B7280', marginBottom: 3 }}>Cant. ingreso</div>
              <input type="number" step="0.01" value={v.ingreso_cantidad ?? ''} disabled={bloqueado} onChange={e => onChange('ingreso_cantidad', e.target.value)}
                style={{ width: '100%', padding: '7px 8px', border: '1px solid #E5E7EB', borderRadius: 6, fontSize: 12, outline: 'none', boxSizing: 'border-box', background: bloqueado ? '#F9FAFB' : 'white' }} />
            </div>
            <div>
              <div style={{ fontSize: 10, fontWeight: 700, color: '#6B7280', marginBottom: 3 }}>Fecha salida</div>
              <input type="date" value={v.salida_fecha || ''} disabled={bloqueado} onChange={e => onChange('salida_fecha', e.target.value)}
                style={{ width: '100%', padding: '7px 8px', border: '1px solid #E5E7EB', borderRadius: 6, fontSize: 12, outline: 'none', boxSizing: 'border-box', background: bloqueado ? '#F9FAFB' : 'white' }} />
            </div>
            <div>
              <div style={{ fontSize: 10, fontWeight: 700, color: '#6B7280', marginBottom: 3 }}>Cant. salida</div>
              <input type="number" step="0.01" value={v.salida_cantidad ?? ''} disabled={bloqueado} onChange={e => onChange('salida_cantidad', e.target.value)}
                style={{ width: '100%', padding: '7px 8px', border: '1px solid #E5E7EB', borderRadius: 6, fontSize: 12, outline: 'none', boxSizing: 'border-box', background: bloqueado ? '#F9FAFB' : 'white' }} />
            </div>
          </div>
          <input type="text" value={v.observacion || ''} disabled={bloqueado} onChange={e => onChange('observacion', e.target.value)} placeholder="Observación..."
            style={{ width: '100%', padding: '8px 10px', border: '1px solid #E5E7EB', borderRadius: 6, fontSize: 12, outline: 'none', boxSizing: 'border-box', background: bloqueado ? '#F9FAFB' : 'white' }} />
        </div>
      )}
    </div>
  );
}

// ─────────────────────────────────────────
// PANTALLA — /inventario-produccion
// ─────────────────────────────────────────
export default function InventarioProduccion() {
  const { usuario } = useAuth();
  const esAdmin = ['gerencia', 'administracion'].includes(usuario?.rol);

  const hoy = format(new Date(), 'yyyy-MM-dd');
  const [fecha] = useState(hoy);
  const [items, setItems] = useState([]);
  const [valores, setValores] = useState({});
  const [registro, setRegistro] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [historial, setHistorial] = useState([]);
  const [vista, setVista] = useState('formulario');
  const [busqueda, setBusqueda] = useState('');
  const [notas, setNotas] = useState('');

  useEffect(() => {
    API.get('/produccion/items').then(r => setItems(r.data)).catch(() => {});
  }, []);

  const cargarRegistro = useCallback(() => {
    setCargando(true);
    API.get('/produccion/registro', { params: { fecha } })
      .then(r => {
        setRegistro(r.data);
        setNotas(r.data?.notas || '');
        if (r.data?.detalle) {
          const v = {};
          r.data.detalle.forEach(d => {
            v[d.item_id] = {
              cantidad_actual: d.cantidad_actual,
              unidad_registrada: d.unidad_registrada || '',
              ingreso_fecha: d.ingreso_fecha ? d.ingreso_fecha.slice(0,10) : '',
              ingreso_cantidad: d.ingreso_cantidad,
              salida_fecha: d.salida_fecha ? d.salida_fecha.slice(0,10) : '',
              salida_cantidad: d.salida_cantidad,
              observacion: d.observacion || '',
            };
          });
          setValores(v);
        } else setValores({});
      })
      .catch(() => { setRegistro(null); setValores({}); })
      .finally(() => setCargando(false));
  }, [fecha]);
  useEffect(() => { cargarRegistro(); }, [cargarRegistro]);

  useEffect(() => {
    if (vista !== 'historial') return;
    API.get('/produccion/historial', { params: { limit: 10 } }).then(r => setHistorial(r.data)).catch(() => {});
  }, [vista]);

  const setValor = (itemId, campo, val) => setValores(prev => ({ ...prev, [itemId]: { ...(prev[itemId] || {}), [campo]: val } }));

  const bloqueado = registro?.estado === 'enviado' && !esAdmin;

  const handleCorregir = async () => {
    try { await API.post('/produccion/corregir', { registro_id: registro.id }); toast.success('Desbloqueado para corrección'); cargarRegistro(); }
    catch { toast.error('Error'); }
  };

  const handleGuardar = async (enviar = false) => {
    setGuardando(true);
    try {
      const detalle = items.map(item => ({
        item_id: item.id,
        cantidad_actual: num(valores[item.id]?.cantidad_actual),
        unidad_registrada: valores[item.id]?.unidad_registrada || null,
        ingreso_fecha: valores[item.id]?.ingreso_fecha || null,
        ingreso_cantidad: num(valores[item.id]?.ingreso_cantidad),
        salida_fecha: valores[item.id]?.salida_fecha || null,
        salida_cantidad: num(valores[item.id]?.salida_cantidad),
        observacion: valores[item.id]?.observacion || null,
      })).filter(d => d.cantidad_actual !== null || d.ingreso_cantidad !== null || d.salida_cantidad !== null || d.observacion);
      await API.post('/produccion/guardar', { fecha, notas, items: detalle, enviar });
      toast.success(enviar ? '✅ Inventario enviado' : '💾 Borrador guardado');
      cargarRegistro();
    } catch (e) { toast.error(e.response?.data?.error || 'Error al guardar'); }
    finally { setGuardando(false); }
  };

  const itemsFiltrados = busqueda ? items.filter(i => i.nombre.toLowerCase().includes(busqueda.toLowerCase()) || i.codigo.toLowerCase().includes(busqueda.toLowerCase())) : items;
  const porCategoria = {};
  itemsFiltrados.forEach(item => { if (!porCategoria[item.categoria]) porCategoria[item.categoria] = []; porCategoria[item.categoria].push(item); });

  const totalDiligenciados = items.filter(i => valores[i.id]?.cantidad_actual !== undefined && valores[i.id]?.cantidad_actual !== '' && valores[i.id]?.cantidad_actual !== null).length;

  const estadoInfo = { borrador: { bg: '#FEF3C7', color: '#92400E', label: 'Borrador' }, enviado: { bg: '#D1FAE5', color: '#065F46', label: 'Enviado ✓' } };
  const mostrarBarra = vista === 'formulario' && !cargando && !bloqueado && items.length > 0;

  return (
    <div style={{ paddingBottom: mostrarBarra ? 78 : 0 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: '#111827' }}>🏭 Inv. Producción</h1>
          <div style={{ fontSize: 13, color: '#6B7280', marginTop: 2 }}>Materias primas e insumos</div>
        </div>
        {registro?.estado && (
          <span style={{ padding: '5px 12px', borderRadius: 20, fontWeight: 700, fontSize: 11, background: estadoInfo[registro.estado]?.bg, color: estadoInfo[registro.estado]?.color }}>
            {estadoInfo[registro.estado]?.label}
          </span>
        )}
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <Pill activo={vista === 'formulario'} onClick={() => setVista('formulario')}>📝 Llenar</Pill>
        <Pill activo={vista === 'historial'} onClick={() => setVista('historial')}>📋 Historial</Pill>
      </div>

      {vista === 'historial' ? (
        <div>
          {historial.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: '#9CA3AF' }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>📋</div>
              <div style={{ fontWeight: 600 }}>Sin registros aún</div>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {historial.map((h, i) => (
                <div key={i} style={{ background: 'white', borderRadius: 14, padding: '12px 16px', boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontWeight: 700, fontSize: 14, color: '#111827' }}>{format(new Date(h.fecha.slice(0,10)+'T12:00'), "d MMM yyyy", { locale: es })}</div>
                    <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: h.estado === 'enviado' ? '#D1FAE5' : '#FEF3C7', color: h.estado === 'enviado' ? '#065F46' : '#92400E' }}>
                      {h.estado === 'enviado' ? '✅ Enviado' : '📝 Borrador'}
                    </span>
                  </div>
                  <div style={{ fontSize: 12, color: '#6B7280', marginTop: 4 }}>{h.encargado_nombre || '—'} · {h.total_items || 0} ítems</div>
                  {h.notas && <div style={{ fontSize: 12, color: '#374151', marginTop: 6, fontStyle: 'italic' }}>{h.notas}</div>}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : cargando ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#9CA3AF' }}>Cargando...</div>
      ) : (
        <>
          {bloqueado && (
            <div style={{ background: '#D1FAE5', border: '1px solid #6EE7B7', borderRadius: 12, padding: '12px 16px', marginBottom: 14, fontSize: 13, color: '#065F46', fontWeight: 600, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              <span>✅ Inventario de hoy ya enviado</span>
            </div>
          )}
          {registro?.estado === 'enviado' && esAdmin && (
            <button onClick={handleCorregir} style={{ width: '100%', padding: '10px 0', border: '2px solid #F59E0B', borderRadius: 10, background: 'white', cursor: 'pointer', fontSize: 12, fontWeight: 700, color: '#92400E', marginBottom: 14 }}>
              ✏️ Permitir corrección
            </button>
          )}

          {/* Progreso */}
          <div style={{ background: 'white', borderRadius: 12, padding: '12px 14px', marginBottom: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 12 }}>
              <span style={{ fontWeight: 700, color: '#374151' }}>Progreso</span>
              <span style={{ color: '#6B7280' }}>{totalDiligenciados} / {items.length} ítems</span>
            </div>
            <div style={{ background: '#F3F4F6', borderRadius: 8, height: 8, overflow: 'hidden' }}>
              <div style={{ height: '100%', borderRadius: 8, background: 'linear-gradient(90deg,#3B4E8C,#5B6FAC)', width: `${items.length ? (totalDiligenciados / items.length) * 100 : 0}%`, transition: 'width 0.3s' }} />
            </div>
          </div>

          {/* Buscador */}
          <input value={busqueda} onChange={e => setBusqueda(e.target.value)} placeholder="🔍 Buscar ítem o código..."
            style={{ width: '100%', padding: '9px 12px', border: '2px solid #E5E7EB', borderRadius: 10, fontSize: 13, outline: 'none', boxSizing: 'border-box', marginBottom: 12 }} />

          {!bloqueado && (
            <div style={{ background: 'white', borderRadius: 12, padding: '12px 14px', marginBottom: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', marginBottom: 6 }}>Observaciones generales</div>
              <textarea value={notas} onChange={e => setNotas(e.target.value)} rows={2} placeholder="Ej: recibimos pedido de Levapan..."
                style={{ width: '100%', padding: '8px 10px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 13, outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit' }} />
            </div>
          )}

          {Object.entries(porCategoria).map(([cat, catItems]) => (
            <div key={cat} style={{ marginBottom: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span style={{ fontSize: 15 }}>{CATEGORIA_ICONS[cat] || '📋'}</span>
                <span style={{ fontWeight: 800, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.03em', color: '#1a1a2e' }}>{cat}</span>
                <span style={{ fontSize: 11, color: '#9CA3AF', fontWeight: 600 }}>({catItems.length})</span>
              </div>
              {catItems.map(item => (
                <TarjetaItem key={item.id} item={item} valor={valores[item.id]} bloqueado={bloqueado}
                  onChange={(campo, val) => setValor(item.id, campo, val)} />
              ))}
            </div>
          ))}
        </>
      )}

      {mostrarBarra && (
        <div style={{ position: 'fixed', left: 0, right: 0, bottom: 'calc(70px + env(safe-area-inset-bottom, 0px))', display: 'flex', gap: 10, padding: '10px 20px', background: 'white', borderTop: '1px solid #E5E7EB', boxShadow: '0 -2px 10px rgba(0,0,0,0.06)', zIndex: 90 }}>
          <button onClick={() => handleGuardar(false)} disabled={guardando}
            style={{ flex: 1, padding: '13px 0', border: '2px solid #1a1a2e', borderRadius: 12, background: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700, color: '#1a1a2e' }}>
            {guardando ? '⏳' : '💾 Borrador'}
          </button>
          <button onClick={() => handleGuardar(true)} disabled={guardando}
            style={{ flex: 2, padding: '13px 0', border: 'none', borderRadius: 12, background: '#1a1a2e', color: 'white', cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>
            {guardando ? '⏳ Enviando...' : '✅ Enviar inventario'}
          </button>
        </div>
      )}
    </div>
  );
}
